<template>
  <div id="app-login-body">
    <!-- 顶栏 -->
    <HeaderMain></HeaderMain>
    <!-- 主容器 -->
    <div class="container" id="app-login-container" style="margin: auto">
      <!-- 注册表单 -->
      <div class="form-container sign-up-container">
        <el-form :model="regForm" :rules="rule2" ref="regForm" @keyup.enter.native="reg()">
          <h1 style="font-size: 25px;letter-spacing: 25px;margin-right: -25px">创建账户</h1>
          <span style="display:block;margin-bottom: 15px">use your email for registration</span>
          <el-form-item label="" prop="account">
            <el-input placeholder="昵称" v-model="regForm.account" autocomplete="off" disableautocomplete></el-input>
          </el-form-item>
          <el-form-item label="" prop="mail">
            <el-input placeholder="Mail" type="email" v-model="regForm.mail" autocomplete="off"
                      disableautocomplete></el-input>
          </el-form-item>
          <el-form-item label="" prop="verifyCode">
            <el-input placeholder="验证码" type="text" v-model="regForm.verifyCode" autocomplete="off"
                      disableautocomplete></el-input>
          </el-form-item>
          <el-form-item label="" prop="pwd">
            <el-input placeholder="Password" type="password" v-model="regForm.pwd" autocomplete="off"
                      disableautocomplete></el-input>
          </el-form-item>
          <el-form-item label="" prop="confirmPwd">
            <el-input placeholder="确认密码" type="password" v-model="confirmPwd" autocomplete="off"
                      disableautocomplete></el-input>
          </el-form-item>
          <el-button type="primary" style="border-radius: 0" v-on:click="reg">提交</el-button>
          <el-button type="primary" id="getVerifyCode"
                     style="position: absolute;right: 5px;bottom: 285px;width: 80px;height: 40px;padding: 0"
                     v-on:click="getVerifyCode">获取验证码
          </el-button>
        </el-form>
      </div>
      <!-- 登录表单 -->
      <div class="form-container sign-in-container">
        <el-form :model="loginForm" :rules="rule" ref="loginForm" @keyup.enter.native="login()">
          <h1 style="font-size: 25px;letter-spacing: 25px;margin-right: -25px">登录</h1>
          <span style="display:block;margin-bottom: 15px">use your account</span>
          <el-form-item label="" prop="mail">
            <el-input placeholder="Email" v-model="loginForm.mail"></el-input>
          </el-form-item>
          <el-form-item label="" prop="pwd">
            <el-input placeholder="Password" type="password" v-model="loginForm.pwd"></el-input>
          </el-form-item>
          <p id="app-login-forget" style="margin: 0;cursor: pointer" v-on:click="forgetPassword">忘记密码</p>
          <el-button type="primary" style="border-radius: 0" v-on:click="login">提交</el-button>
        </el-form>
      </div>
      <!-- 可移动封面 -->
      <div class="overlay-container">
        <div class="overlay">
          <div class="overlay-panel overlay-left">
            <button class="ghost" id="signIn">登录</button>
          </div>
          <div class="overlay-panel overlay-right">
            <button class="ghost" id="signUp">注册</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import DataStorePersisted from "@/components/dataStorePersisted";
import util from "@/components/util";
import {Message} from "element-ui";
import AxiosBase from "@/components/axiosBase";
import HeaderMain from "@/views/share/HeaderMain";

export default {
  name: "Login",
  components: {
    HeaderMain
  },
  data() {
    const validateMail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户邮箱'));
      } else {
        if (!util.verifyMail(value)) {
          callback(new Error('请输入正确的邮箱'));
        }
        callback();
      }
    };
    const validateConfirmPwd = (rule, value, callback) => {
      if (this.confirmPwd === '') {
        callback(new Error('请再次输入密码'))
      } else {
        if (this.confirmPwd !== this.regForm.pwd) {
          callback(new Error('两次输入的密码不同'));
        }
        callback();
      }
    }
    return {
      loginForm: {
        mail: '',
        pwd: ''
      },
      regForm: {
        account: '',
        mail: '',
        verifyCode: '',
        pwd: '',
      },
      confirmPwd: '',
      rule: {
        mail: [
          {validator: validateMail, trigger: 'blur'}
        ],
        pwd: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 8, max: 256, message: '请输入正确长度的密码[8-256]', trigger: 'blur'}
        ]
      },
      rule2: {
        account: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 3, max: 8, message: '请输入正确长度的用户名', trigger: 'blur'}
        ],
        mail: [
          {validator: validateMail, trigger: 'blur'}
        ],
        verifyCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {min: 6, max: 6, message: '请输入正确的验证码', trigger: 'blur'}
        ],
        pwd: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 8, max: 256, message: '请输入正确长度的密码', trigger: 'blur'}
        ],
        confirmPwd: [
          {validator: validateConfirmPwd, trigger: 'blur'}
        ]
      }
    }
  },
  mounted() {
    document.title = "斑斓魔法CG-登录";

    const signUpButton = document.getElementById('signUp');
    const signInButton = document.getElementById('signIn');
    const container = document.getElementById('app-login-container');

    signUpButton.addEventListener('click', () => {
      container.classList.add("right-panel-active");
    });

    signInButton.addEventListener('click', () => {
      container.classList.remove("right-panel-active");
    });
  },
  methods: {
    login() {
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          this.loginForm.pwd = util.MD5(this.loginForm.pwd)
          AxiosBase.axiosPost("/user/login", this.loginForm).then(response => {
            if (response !== 0) {
              Message({
                showClose: true,
                message: response.data,
                type: 'success'
              });
              DataStorePersisted.state.isLogin = true;
              this.$router.push("/");
            }
          })
        }
      });
    },
    getVerifyCode() {
      if (util.verifyMail(this.regForm.mail)) {
        util.buttonCollDown('getVerifyCode', 30, "获取验证码");
        AxiosBase.axiosGet("/user/code", {
          params: {
            mail: this.regForm.mail
          }
        }).then(response => {
          if (response !== 0) {
            Message({
              showClose: true,
              message: response.data,
              type: 'success'
            });
          }
        })
      } else {
        Message({
          showClose: true,
          message: '请输入正确的邮箱格式',
          type: 'error'
        });
      }

    },
    reg() {
      this.$refs['regForm'].validate((valid) => {
        if (valid) {
          //开始验证验证码
          AxiosBase.axiosGet("/user/code-verify", {
            params: {
              mail: this.regForm.mail,
              verifyCode: this.regForm.verifyCode
            }
          }).then(response => {
            if (response !== 0) {
              AxiosBase.axiosPost("/user/reg", this.regForm).then(regResponse => {
                if (regResponse !== 0) {
                  Message({
                    showClose: true,
                    message: regResponse.data,
                    type: 'success'
                  });
                  document.getElementById('app-login-container').classList.remove("right-panel-active");
                }
              })
            }
          })
        }
      });
    },
    forgetPassword() {
      if (util.verifyMail(this.loginForm.mail)) {

        this.$confirm('是否需要发送忘记密码邮件到邮箱？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          AxiosBase.axiosGet("/user/forget", {
            params: {
              mail: this.loginForm.mail
            }
          }).then(response => {
            if (response !== 0) {
              Message({
                showClose: true,
                message: '修改密码邮件已经发送到邮箱中',
                type: 'success'
              })
              let element = document.getElementById("app-login-forget");
              element.style.cursor = "auto";
              element.setAttribute("disabled", "disabled")
              element.innerText = "验证码已发送到邮箱";
            }
          })
        })
      } else {
        Message({
          showClose: true,
          message: '请在登陆框中输入正确格式的邮箱地址',
          type: 'warning'
        })
      }
    }
  }
}
</script>

<style scoped>

* {
  box-sizing: border-box;
}

#app-login-body {
  text-align: center;
  margin-top: 175px;
}

span {
  font-size: 12px;
}

a {
  color: #333;
  font-size: 14px;
  text-decoration: none;
  margin: 15px 0;
}

button {
  border: 1px solid #FF8A00;
  background-color: #FF8A00;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: bold;
  padding: 12px 45px;
  letter-spacing: 1px;
  text-transform: uppercase;
  width: 225px;
  transition: transform 80ms ease-in;
  margin-top: 10px;
}

button:active {
  transform: scale(0.95);
}

button:focus {
  outline: none;
}

button.ghost {
  background-color: transparent;
  border-color: #FFFFFF;
  color: #FFFFFF;
  width: 100%;
}

form {
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 50px;
  height: 100%;
  text-align: center;
}

input {
  background-color: #eee;
  border: none;
  padding: 12px 15px;
  margin: 8px 0;
  width: 100%;
}

.container {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 5px 7px 13px rgba(0, 0, 0, 0.025),
  2px 2px 2px rgba(0, 0, 0, 0.025);
  position: relative;
  overflow: hidden;
  width: 768px;
  max-width: 100%;
  min-height: 480px;
}

.form-container {
  position: absolute;
  top: 0;
  height: 100%;
  transition: all 0.6s ease-in-out;
}

.sign-in-container {
  left: 0;
  width: 50%;
  z-index: 2;
}

.container.right-panel-active .sign-in-container {
  transform: translateX(100%);
}

.sign-up-container {
  left: 0;
  width: 50%;
  opacity: 0;
  z-index: 1;
}

.container.right-panel-active .sign-up-container {
  transform: translateX(100%);
  opacity: 1;
  z-index: 5;
  animation: show 0.6s;
}

@keyframes show {
  0%, 49.99% {
    opacity: 0;
    z-index: 1;
  }

  50%, 100% {
    opacity: 1;
    z-index: 5;
  }
}

.overlay-container {
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  overflow: hidden;
  transition: transform 0.6s ease-in-out;
  z-index: 100;
}

.container.right-panel-active .overlay-container {
  transform: translateX(-100%);
}

.overlay {
  background-image: url("../../assets/img/loginBackground.png");
  background-size: cover;
  color: #202020;
  position: relative;
  left: -100%;
  height: 100%;
  width: 200%;
  transform: translateX(0);
  transition: transform 0.6s ease-in-out;
}

.container.right-panel-active .overlay {
  transform: translateX(50%);
}

.overlay-panel {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 40px;
  text-align: center;
  top: 0;
  height: 100%;
  width: 50%;
  transform: translateX(0);
  transition: transform 0.6s ease-in-out;
  color: #FFFFFF;
}

.overlay-left {
  transform: translateX(-20%);
}

.container.right-panel-active .overlay-left {
  transform: translateX(0);
}

.overlay-right {
  right: 0;
  transform: translateX(0);
}

.container.right-panel-active .overlay-right {
  transform: translateX(20%);
}

</style>